import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { CvUploadValidationResponse } from './models/cv-upload-validation.model';
import { CvUploadResponse } from './models/cv-upload-response.model';

@Injectable({ providedIn: 'root' })
export class CvUploadService {
  private readonly apiServerUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  public validateToken(token: string): Observable<CvUploadValidationResponse> {
    const params = new HttpParams().set('token', token);
    return this.http.get<CvUploadValidationResponse>(
      `${this.apiServerUrl}/public/cv-upload/validate`,
      { params }
    );
  }

  public uploadCv(token: string, file: File): Observable<CvUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const params = new HttpParams().set('token', token);
    return this.http.post<CvUploadResponse>(
      `${this.apiServerUrl}/public/cv-upload`,
      formData,
      { params }
    );
  }
}
